import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import CTA from "@/components/CTA";
import FacebookSection from "@/components/FacebookSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import useReveal from "@/hooks/useReveal";

export default function Home() {
  useReveal();
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <WhyUs />
      <Process />
      <CTA />
      <FacebookSection />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
